import React from "react";
import Select from "react-select";

const EmploymentTypeSelect = ({ value, onChange, isMulti = false }) => {
  const options = [
    { value: 'full-time', label: "Full-Time" },
    { value: 'part-time', label: "Part-Time" },
    { value: 'temporary', label: "Temporary / Seasonal" },
    { value: 'contract', label: "Contract / Freelance" },
    { value: 'internship', label: "Internship" },
    { value: 'probationary', label: "Probationary / Trial Period" },
    { value: 'remote', label: "Remote / Telecommuting" },
    { value: 'permanent', label: "Permanent" },
    { value: 'on-call', label: "On-Call" },
    { value: 'commission-based', label: "Commission-Based" }
  ];

  // Handle change differently based on isMulti
  const handleChange = (selectedOption) => {
    if (isMulti) {
      onChange(selectedOption ? selectedOption.map(option => ({ value: option.value, label: option.label })) : []);
    } else {
      onChange(selectedOption ? { value: selectedOption.value, label: selectedOption.label } : null);
    }
  };

  // Custom styles for the Select component
  const customStyles = {
    control: (provided) => ({
      ...provided,
      backgroundColor: '#f9f9f9', // Apply background color
      borderColor: '#ddd', // Apply border color
    }),
    menu: (provided) => ({
      ...provided,
      zIndex: 9999, // Ensure dropdown appears above other elements
    }),
    placeholder: (provided) => ({
      ...provided,
      color: '#666666', // Customize placeholder color
    }),
  };

  return (
    <Select
      options={options}
      placeholder="Select Employment Type"
      value={
        isMulti
          ? value && Array.isArray(value) ? value.map(val => options.find(option => option.value === val.value)) : []
          : value ? options.find(option => option.value === value.value) || null : null
      }
      onChange={handleChange}
      styles={customStyles} // Apply custom styles here
      isClearable
      isMulti={isMulti} // Enable multi-select if isMulti is true
    />
  );
};

export default EmploymentTypeSelect;
